export default {
  payNowButtonText: 'Pay Now',
  payNowModalTitle: 'Pay My Bill Now',
  paymentForm: {
    totalOwed: 'Total Owed',
    totalPaid: 'Previous Total Paid',
    balance: 'Balance',
    addNewCard: 'Add New Card',
    howMuchToPay: 'How much of your balance would you like to pay?',
    paymentAmount: 'Payment Amount',
    cancel: 'Cancel',
    confirmPayment: 'Confirm Payment',
  },
  addNewCardModalTitle: 'Add New Card',
  addNewCardForm: {
    nameOnCardLabel: 'Name on Card',
    cardNumberLabel: 'Card Number',
    expirationDateLabel: 'Expiration',
    securityCodeLabel: 'Security Code',
    billingAddressHeader: 'Billing Address',
    cancel: 'Cancel',
    submitCard: 'Save and Use Card',
    cardSaving: 'Saving card...',
  },
};
